import { z } from 'zod';

import { ChatChannelSchema } from '../card/card';

/**
 * Channel-agnostic reference to a contact on an external messaging
 * surface. The pair (`channel`, `externalId`) is the canonical threading
 * key — the same `externalId` on two different channels is two distinct
 * contacts at this layer; merging happens later (v1.2+).
 */
export const ContactRefSchema = z
  .object({
    channel: ChatChannelSchema,
    externalId: z.string().min(1).max(200),
    displayName: z.string().max(200).optional(),
  })
  .strict();

export type ContactRef = z.infer<typeof ContactRefSchema>;
